import styles from "../upsc-prestorming-prelims-test-series/prestorming.module.css";
import Link from "next/link";
import Image from "next/image";
import phone from "../../assets/images/upsc/phone.png";
import NewiconA from "../../assets/images/header/pdf-download1.png";
const Prelims = () => {

   const feestructure3 =[

    {center: "AnnaNagar",mode: (<><div>Batch 1 - Regular</div><div>(Only Offline)</div></>), start: "7th Sep 2026",
          cont3:(<Link href="https://www.shankariasacademy.com/pdf/UPSC-2026/prestorming-2026/AnnaNagar/Prestorming-B1-AnnaNagar-2026-27.pdf" target="_blank" className={`${styles.paybill}`}> 
                <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/>Download PDF </Link>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=PRESTORMING" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                      Pay Now
                    </button>
                </a>)
            },

    {center: "AnnaNagar",mode: (<><div>Batch 2 - Regular</div><div>(Online & Offline)</div></>), start: "10th Oct 2026",
          cont3:(<Link href="https://www.shankariasacademy.com/pdf/UPSC-2026/prestorming-2026/AnnaNagar/Prestorming-B2-AnnaNagar-2026-27.pdf" target="_blank" className={`${styles.paybill}`}> 
                <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/>Download PDF </Link>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=PRESTORMING" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                      Pay Now
                    </button>
                </a>)
            },

    {center: "Adyar",mode: (<><div>Batch 2 - Regular</div><div>(Online & Offline)</div></>), start: "10th Oct 2026",
          cont3:(<Link href="https://www.shankariasacademy.com/pdf/UPSC-2026/prestorming-2026/Adyar/Prestorming-B2-2026-27-Adyar.pdf" target="_blank" className={`${styles.paybill}`}> 
                <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/>Download PDF </Link>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ADYAR&coursetype=PRESTORMING" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                      Pay Now
                    </button>
                </a>)
            },

    ];

  return (
  <>

    <section  id="courseandfees">
        <div className="container pt-xl-4" >
          <div className="row">
            <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#ffbdac" }}>Center</div>
            <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#fee5d3" }}>Batch</div>
            <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#ffbdac" }}>Starts on</div>
            <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#fee5d3" }}>Schedule</div> 
            <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#ffbdac" }}>Admission</div>
              <hr/>
          </div>
                        
          {feestructure3.map((item,index)=>(
            <div className={`${styles.facultyborder3} row`}>
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Center</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-3`}>{item.center}</div>
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Batch</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3  pb-md-3`}>{item.mode}</div>
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Starts on</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3`}>{item.start}</div>
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Schedule</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-2`}>{item.cont3}</div> 
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Admission</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-2 text-center pt-2 pt-md-2`}>
              {item.pay}
            </div>
              <hr/>
            </div>
          ))} 
          <p className={`${styles.acheiverrank1} pt-3 pb-2`}><span style={{color:"#e21111ff"}}>Note :</span> Prestorming Batch 1- 7th Sep (Only Annanagar)<sup className= {`${styles.dot1}`}>*</sup></p>
        </div>
      
    </section>

    <div className="container pt-4 mb-3">
      <div className="row">
        <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12 pt-3">
          <div className={`${styles.facultyborder3} p-4 h-100`}>
            <p className={`${styles.sectionsubtitle}`}>GS + CSAT</p>
            <div className="row ">
              <div className="col-lg-4 col-5 col-md-6">
                <p className={`${styles.sectionredtitle} mb-0`}><b>₹</b>9,500/-</p>
              </div>
              <div className="col-lg-8 col-7 col-md-6">
                <p className={`${styles.acheiverrank} px-xl-4 mb-0`}>New Students</p>
              </div>
            </div>
            <div className="row pt-3">
              <div className="col-lg-4 col-5 col-md-6">
                <p className={`${styles.sectionredtitle}`}><b>₹</b>8,500/-</p>
              </div>
              <div className="col-lg-8 col-7 col-md-6">
                <p className={`${styles.acheiverrank} px-xl-4`}>Old Students</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12 pt-3">
          <div className={`${styles.facultyborder3} p-4 h-100`}>
            <p className={`${styles.sectionsubtitle}`}>GS</p>
            <div className="row">
              <div className="col-lg-4 col-5 col-md-6">
                <p className={`${styles.sectionredtitle} mb-0`}><b>₹</b>9,000/-</p>
              </div>
              <div className="col-lg-8 col-7 col-md-6">
                <p className={`${styles.acheiverrank} px-xl-4 mb-0`}>New Students</p>
              </div>
            </div>
            <div className="row pt-3">
              <div className="col-lg-4 col-5 col-md-6">
                <p className={`${styles.sectionredtitle}`}><b>₹</b>8,000/-</p>
              </div>
              <div className="col-lg-8 col-7 col-md-6">
                <p className={`${styles.acheiverrank} px-xl-4`}>Old Students</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12 pt-3">
          <div className={`${styles.facultyborder3} p-4 h-100`}>
            <p className={`${styles.sectionsubtitle}`}>CSAT</p>
            <div className="row">
              <div className="col-lg-4 col-5 col-md-6">
                <p className={`${styles.sectionredtitle}`}><b>₹</b>1,500/-</p>
              </div>
              
            </div>
            {/* <div className="row">
              <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.acheiverrank} px-xl-4`}>Old Students</p>
              </div>
              
            </div> */}
          </div>
        </div>
      </div>
    </div> 

    <div className="container py-2 pb-4">
      <div className="row">
        <div className= "col-lg-6 col-12 pt-2">
          <div className={`${styles.prebg}`}>
            <h2 className={`${styles.aboutheading1}`}>Anna Nagar Venue</h2>
            <p className={`${styles.acheiverrank1} ${styles.dark} mb-0`}><Image src={phone} alt="Shankar IAS Academy annanagar contact number" title="Contact number" className={`${styles.phoneiconcss} img-fluid pe-2`} /> <a href="tel:9003190030" className={`${styles.numberbold}`}>90031 90030</a> <b>,</b> <a href="tel:044-66024500" className={`${styles.numberbold}`} >044-66024500</a></p>
            <p className={`${styles.acheiverrank1} mb-0`}>Door No 18, Old Plot No 109,</p>
            <p className={`${styles.acheiverrank1} mb-0`}>New Plot No 259, AL Block, 4th Avenue,</p>
            <p className={`${styles.acheiverrank1} mb-0`}>Shanthi Colony, Annanagar,</p>
            <p className={`${styles.acheiverrank1} mb-0`}>Chennai 600040.</p>
            <p className={`${styles.redunderline} pt-3`}><Link href="https://www.google.com/maps/place/Shankar+IAS+Academy+Chennai/@13.0823643,80.2047976,17z/data=!3m1!4b1!4m6!3m5!1s0x3a52654d8fc25ff7:0x9b278e8700a30d6!8m2!3d13.0823643!4d80.2047976!16s%2Fg%2F11fjr76z1j?entry=ttu" rel="noreferrer" target="_blank" className={`${styles.redunderlinealink}`}>Get Direction</Link></p>
          </div>
          
        </div>

        <div className="col-lg-6 col-12 pt-2 pb-4">
          <div className={`${styles.prebg}`}>
              <h2 className={`${styles.aboutheading1}`}>Adyar Venue</h2>
              <p className={`${styles.acheiverrank1} ${styles.dark} mb-0`}><Image src={phone} alt="Shankar IAS Academy annanagar contact number" title="Contact number" className={`${styles.phoneiconcss} img-fluid pe-2`} /> <a href="tel:90252 78278" className={`${styles.numberbold}`} >90252 78278</a></p>
              <p className={`${styles.acheiverrank1} mb-0`}>No-2/23, 3rd Cross Street,</p>
              <p className={`${styles.acheiverrank1} mb-0`}>Padmanabhanagar, Adyar,</p>
              <p className={`${styles.acheiverrank1} mb-4`}>Chennai-600 020, Tamil Nadu.</p>
              <p className={`${styles.redunderline} pt-3`}><Link href="https://www.google.com/maps/place/Shankar+IAS+Academy+Adyar+%7C+UPSC+coaching+center+in+Adyar/@13.0498946,80.1958975,13z/data=!4m7!3m6!1s0x3a5267ec667c66d7:0x920d4111ec2c3ce6!8m2!3d13.0050985!4d80.2588174!15sChNzaGFua2FyIGlhcyBhY2FkZW15IgOIAQFaFSITc2hhbmthciBpYXMgYWNhZGVteZIBD2NvYWNoaW5nX2NlbnRlcuABAA!16s%2Fg%2F11cn5nj825?coh=164777&entry=tt&shorturl=1" rel="noreferrer" target="_blank" className={`${styles.redunderlinealink}`}>Get Direction</Link></p>
          </div>
          
          <div className={`${styles.presbg}`}>
            {/*<p className={`${styles.acheiverrank1} mb-0`}><Link href="/pdf/upsc-prelims-test-series-2023/Prestorming-batch-2-adyar_compressed.pdf" rel="noreferrer" target="_blank" className={`${styles.program}`}>Prestorming 2023 - 2024 Batch II (Oct 15th) Schedule <i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i></Link></p>
              <p className={`${styles.acheiverrank1} mb-0`}><Link href="/pdf/upsc-prelims-test-series-2023/Prestorming-batch-2-adyar_compressed.pdf" rel="noreferrer" target="_blank" className={`${styles.program}`}>Prestorming 2023 - 2024 Batch III (Nov 16th) Schedule</Link></p>
              <p className={`${styles.acheiverrank1} mb-0`}><Link href="/pdf/upsc-prelims-test-series-2023/Prestorming-batch-4-Adyar_compressed.pdf" rel="noreferrer" target="_blank" className={`${styles.program}`}>Prestorming 2023 - 2024 Batch IV (Dec 10th) Schedule</Link></p> */}
        </div>
        </div>
      </div>
    </div>

  </>
  );
};

export default Prelims;